import { render, staticRenderFns } from "./registration-footer.vue?vue&type=template&id=4b964163&scoped=true&"
import script from "./registration-footer.vue?vue&type=script&lang=js&"
export * from "./registration-footer.vue?vue&type=script&lang=js&"
import style0 from "./registration-footer.vue?vue&type=style&index=0&id=4b964163&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b964163",
  null
  
)

component.options.__file = "registration-footer.vue"
export default component.exports